<template>
	<router-link class="small-card" :to="to" tag="div" exact>
		<div v-ripple class="small-card">
			<v-icon class="small-card-icon" size="2em" :color="color2">{{
				icon
			}}</v-icon>
			<p><slot>Mis carreras</slot></p>
		</div>
	</router-link>
</template>

<script>
	export default {
		props: {
			icon: String,
			text: String,
			color1: String,
			color2: String,
			to: Object,
		},
		computed: {},
	};
</script>

<style lang="scss" scoped>
	@import "../../scss/_mixins.scss";
	.small-card {
		width: 100%;
		height: 4em;
		display: flex;
		align-items: center;

		.small-card-icon,
		p {
			color: #fff;
		}

		.small-card-icon {
			justify-self: start;
			border-radius: 50%;
			padding: 0.2em;
			flex: 1;
			margin-left: 1em;
		}

		p {
			padding: 0 1em;
			flex: 5;
			margin: 0;
			font-weight: 400;
			font-size: 1em;
			color: #b0b0b6;
		}

		&:hover {
			background-color: #191921;
			cursor: pointer;
		}
	}

	.router-link-exact-active {
		position: relative;
		&::before {
			content: "";
			width: 4px;
			height: 100%;
			position: absolute;
			left: 0;
			background-color: #bfaa7f;
			border-top-left-radius: 2px;
			border-bottom-left-radius: 2px;
		}

		background-color: #292931;
	}
</style>